import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/aw-camp-people.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/aw-sponsor.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/public/what-is-aw-camp.webp");
;
import(/* webpackMode: "eager" */ "/Users/dawid/Work/aw-sport/src/components/animation/AnimateBoxSlideDown.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/dawid/Work/aw-sport/src/components/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/dawid/Work/aw-sport/src/sections/aw-sport-camp/VideoSection.tsx");
